/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2023-08-18 10:59:31
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-14 13:49:18
 */
export default {
  //转换style css
  transformStyle(options) {
    let style = ''
    Object.keys(options).forEach(key => {
      style += key.replace(/([A-Z])/g, function (match) {
        return '-' + match.toLowerCase()
      })
      style += ":"
      let value = options[key]
      if (Array.isArray(value)) {
        value = value.join('px ')
      } else if (dsf.isNumber(value)) {
        value += 'px'
      }
      style += value + ';'
    })
    return style
  },
  //获取地图数据
  getMapData(url) {
    return new Promise((resolve, reject) => {
      if (typeof url === 'string') {
        dsf.http.get(url).then((res) => {
          if (res.status === 200) {
            let data = res.data;
            resolve(data);
          }
        });
      } else if (url && typeof url === 'object') {
        resolve(url);
      } else {
        resolve({});
      }
    });
  },
  //面转线 geojson
  getPolygonToLine(data) {
    let features = data.features.map(feature => {
      if (feature.geometry.type === "Polygon") {
        feature.geometry.type = "MultiPolygon"
        feature.geometry.coordinates = [feature.geometry.coordinates]
      }
      return turf.polygonToLine(feature)
    })
    data.features = features.reduce((total, cur) => total.concat(cur.features), [])
    return data
  },
  // 转多面 coordinates[三位数组]
  multiPolygonFromPoint(coordinates, properties) {
    return turf.multiPolygon(coordinates, properties);
  },
  //点位转feature
  point() {
    return turf.point(...arguments)
  },
  polygon() {
    return turf.polygon(...arguments)
  },
  centroid() {
    return turf.centroid(...arguments)
  },
  //将feature生成标准的geojson
  featureCollection() {
    return turf.featureCollection(...arguments)
  },
  //点位转线feature
  lineString() {
    return turf.lineString(...arguments)
  },
  //简化geojson
  simplify() {
    return turf.simplify(...arguments)
  },
  //获取面中心点
  getCentroid(feat) {
    let type = feat.type
    let polygons = []
    if (type == 'MultiPolygon') {
      polygons = feat.coordinates[0]
    } else if (type == 'Polygon') {
      polygons = feat.coordinates
    }

    if (Array.isArray(polygons[0]) && polygons.length) {
      polygons = turf.polygon(polygons)
      let re = turf.centroid(polygons)

      return re ? re.geometry.coordinates : []
    }
    return []
  },
  //label 字符串模板转函数 {a} 系列名 {b} 数据名称 {c} 数据值 
  labelStringToFunction(temp) {
    //如果是模板字符串
    if (typeof temp === "string" && /(?={a})|(?={b})|(?={c})+/.test(temp)) {
      temp = temp.replace(/{a}/g, '^^{{properties.seriesName}}^^').replace(/{b}/g, '^^{{properties.name}}^^').replace(/{c}/g, '^^{{properties.value}}^^').split("^^")
      let code = `
          var result = "";
          var temp = "${temp}";
          temp = temp.split(",")
          with(f){
            temp.forEach(function(it){
              if(/^{{.+?}}$/g.test(it)){
                result += eval(it.replace(/{{|}}/g,""))||"--"
              }else {
                result += it
              }
            })
          }
        return result
      `
      return new Function('f', code)

    } else {
      return temp
    }

  },
  //颜色插值算法
  rangeColor(start, end, min, max, value) {
    let { r: sr, g: sg, b: sb } = tinycolor(start).toRgb()
    let { r: er, g: eg, b: eb } = tinycolor(end).toRgb()
    let colorStart = [sr, sg, sb]
    let colorEnd = [er, eg, eb]
    let m = 0
    if (max > min) {
      m = (value - min) / (max - min)
    }
    m = m > 1 ? 1 : m
    let r = parseInt(colorStart[0] + (colorEnd[0] - colorStart[0]) * m)
    let g = parseInt(colorStart[1] + (colorEnd[1] - colorStart[1]) * m)
    let b = parseInt(colorStart[2] + (colorEnd[2] - colorStart[2]) * m)

    return `rgb(${r},${g},${b})`
  },
  //分段颜色计算
  separateColor(value, rules, defaultColor = "#008CFF") {
    let color = defaultColor
    rules.forEach(it => {
      let rule = it.value
      let v = it.color
      if (eval(`${value}>=${rule}`)) {
        color = v
      }
    })
    return color
  },
  // 解析polygon为geojson格式
  analysisIslandCave(data) {
    const polygons = data.split("|").map((item) => {
      const points = item.split(";").map((point) => {
        const num = point.split(",");
        return [+num[0], +num[1]];
      });
      const _points = [];
      let lastIndex = 0;
      let firstPoint = points[lastIndex];
      for (let index = 1; index < points.length; index++) {
        const point = points[index];
        if (point[0] === firstPoint[0] && point[1] === firstPoint[1]) {
          const slicePoints = points.slice(lastIndex, ++index);
          _points.push(slicePoints);
          lastIndex = index;
          if (lastIndex === points.length) break;
          firstPoint = points[lastIndex];
        }
      }
      return _points;
    });
    return turf.multiPolygon(polygons);
  },
  handleDataToThreeDimensions(data) {
    return Array.isArray(data[0])
      ? Array.isArray(data[0][0])
        ? Array.isArray(data[0][0][0])
          ? data
          : [data]
        : []
      : [];
  },
  // 颜色透明度转换
  transColorOpacity(color, opacity) {
    const colorValue = tinycolor(color);
    const transparentColor = colorValue.setAlpha(opacity).toRgbString();
    return transparentColor;
  }
}